import type { FC, ReactNode } from 'react';
import { memo, useMemo } from 'react';

import { getLabelParts } from './helpers';

import type { CallItem } from 'features/ui/components/';
import { CallDropdown } from 'features/ui/components/';

export interface CallHistoryItem {
  id: string | number;
  label: ReactNode;
}

export interface CallHistoryDropdownProps {
  items: CallHistoryItem[];
  selectedId: string | number;
  onChange: (id: string | number) => void;
}

export const CallHistoryDropdown: FC<CallHistoryDropdownProps> = memo(
  function CallHistoryDropdown({ items, selectedId, onChange }) {
    const callItems: CallItem[] = useMemo(
      () =>
        items.map((item) => {
          const [number, time] = getLabelParts(item);
          return {
            id: item.id,
            number,
            time,
          };
        }),
      [items]
    );

    return (
      <CallDropdown
        items={callItems}
        selectedId={selectedId}
        onChange={onChange}
      />
    );
  }
);
